module.exports = __webpack_public_path__ + "img/avatar-9.055a9197.png";